<div class="filter-div">
  <label class="filter-text"> Filter </label>
  <div *ngFor="let option of groupStatusOptions">
    <label class="checkbox-label">
      <mat-checkbox
        type="checkbox"
        name="options"
        value="{{ option.value }}"
        [(ngModel)]="option.checked"
        (change)="emitSelectedOptions()"
        class="group-status-checkbox"
      >
      </mat-checkbox>
      <img
        [src]="'../../assets/images/' + option.value + '.svg'"
        class="group-status-img"
        [alt]="option.value"
        *ngIf="option.value"
      />
      {{ option.name }}
    </label>
  </div>
</div>
